import apiClient from "../config/api";

const fiveSService = {
  getAllAudits: async () => {
    try {
      const response = await apiClient.get("/fives");
      return response.data;
    } catch (error) {
      console.error("Failed to fetch audits", error);
      throw error;
    }
  },

  getAuditById: async (id) => {
    try {
      const response = await apiClient.get(`/fives/${id}`);
      return response.data;
    } catch (error) {
      console.error("Failed to fetch audit", error);
      throw error;
    }
  },

  createAudit: async (data) => {
    try {
      const response = await apiClient.post("/fives", data);
      return response.data;
    } catch (error) {
      console.error("Failed to create audit", error);
      throw error;
    }
  },

  updateAudit: async (id, data) => {
    try {
      const response = await apiClient.post(`/fives/update/${id}`, data);
      return response.data;
    } catch (error) {
      console.error("Failed to update audit", error);
      throw error;
    }
  },

  deleteAudit: async (id) => {
    try {
      const response = await apiClient.post(`/fives/delete/${id}`);
      return response.data;
    } catch (error) {
      console.error("Failed to delete audit", error);
      throw error;
    }
  },

  getChecklistMaster: async () => {
    try {
      const response = await apiClient.get("/fives/checklist-master");
      // If API returns empty (no master set yet for tenant), fallback to default
      if (!response.data || Object.keys(response.data).length === 0) {
           return {
            Sort: [
              "Are necessary and unnecessary items separated?",
              "Are unnecessary items removed from the workplace?",
              "Are gangways and exits clear?",
            ],
            SetInOrder: [
              "Is there a place for everything and everything in its place?",
              "Are tools and equipment labeled and stored correctly?",
              "Are floor markings clear and visible?",
            ],
            Shine: [
              "Is the floor clean and free of debris?",
              "Are machines and equipment clean?",
              "Is the lighting adequate and clean?",
            ],
            Standardize: [
              "Are SOPs displayed and accessible?",
              "Are roles and responsibilities clearly defined?",
              "Are visual standards established and followed?",
            ],
            Sustain: [
              "Are 5S audits conducted regularly?",
              "Is 5S training provided to all employees?",
              "Are improvements tracked and sustained?",
            ],
          };
      }
      return response.data;
    } catch (error) {
      console.error("Failed to get checklist master", error);
      throw error;
    }
  },

  saveChecklistMaster: async (masterData) => {
    try {
      const response = await apiClient.post("/fives/checklist-master", masterData);
      return response.data;
    } catch (error) {
      console.error("Failed to save checklist master", error);
      throw error;
    }
  },
};

export default fiveSService;
